import React from 'react';

import DiscoveryEventList from './discovery-event-list';
import SellEventList from './sell-event-list';

/**
 * Defines a list of EventItem components based on number of events
 *
 * If app is sell, then instantiate the EventList for sell
 * Else, instantiate discovery's EventList
 */

/**
 *
 */
const EventList = (props) => (props.isSell ? <SellEventList {...props} /> : <DiscoveryEventList {...props} />);

export default EventList;
